import { createCallWithToast } from "@glow/react/utils/toast";

export const callWithToast = createCallWithToast();
